module.exports = __webpack_public_path__ + "static/media/IMG_3582-min.b52573b7.JPG";